import axios from "axios";
import { User_Service_URL } from "../Url";

export const saveAddUserActions = {
  SAVE_ADD_USER_DETAILS_SUCCESS: "SAVE_ADD_USER_DETAILS_SUCCESS",
  SAVE_ADD_USER_DETAILS_ERROR: "SAVE_ADD_USER_DETAILS_ERROR",
};

export const getPartnerUserPrimaryActions = {
  GET_PARTNER_USER_PRIMARY_SUCCESS: "GET_PARTNER_USER_PRIMARY_SUCCESS",
  GET_PARTNER_USER_PRIMARY_ERROR: "GET_PARTNER_USER_PRIMARY_ERROR",
};

export const deletePartnerUserRoleActions = {
  DELETE_PARTNER_USER_ROLE_SUCCESS: "DELETE_PARTNER_USER_ROLE_SUCCESS",
  DELETE_PARTNER_USER_ROLE_ERROR: "DELETE_PARTNER_USER_ROLE_ERROR",
};

export function saveAddUserDetails(props) {
  const { access_token, values } = props;
  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + access_token,
        "Access-Control-Allow-Origin": "*",
      },
      url: `${User_Service_URL}/save/Users`,
      data: values,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(saveAddUserSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(saveAddUserError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(saveAddUserError(err));
          return err.response;
        }
      });
}

export function saveAddUserError(error) {
  return {
    type: saveAddUserActions.SAVE_ADD_USER_DETAILS_ERROR,
    payload: error,
  };
}

export function saveAddUserSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: saveAddUserActions.SAVE_ADD_USER_DETAILS_SUCCESS,
      payload: props,
    });
  };
}

export function setPartnerUserPrimaryDetails(props) {
  const { access_token, userId } = props;
  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + access_token,
        "Access-Control-Allow-Origin": "*",
      },
      url: `${User_Service_URL}/makePartnerUserIsPrimary?userId=${userId}`,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(getPartnerUserPrimarySuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(getPartnerUserPrimaryError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(getPartnerUserPrimaryError(err));
          return err.response;
        }
      });
}

export function removePartnerUserPrimary(props) {
  const { access_token, userId } = props;
  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + access_token,
        "Access-Control-Allow-Origin": "*",
      },
      url: `${User_Service_URL}/removePartnerUserIsPrimary?userId=${userId}`,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(getPartnerUserPrimarySuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(getPartnerUserPrimaryError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(getPartnerUserPrimaryError(err));
          return err.response;
        }
      });
}

export function getPartnerUserPrimaryError(error) {
  return {
    type: getPartnerUserPrimaryActions.GET_PARTNER_USER_PRIMARY_ERROR,
    payload: error,
  };
}

export function getPartnerUserPrimarySuccess(props) {
  return (dispatch) => {
    dispatch({
      type: getPartnerUserPrimaryActions.GET_PARTNER_USER_PRIMARY_SUCCESS,
      payload: props,
    });
  };
}

export function deletePartnerUserRole(props) {
  const { access_token, values } = props;

  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + access_token,
        "Access-Control-Allow-Origin": "*",
      },
      url: `${User_Service_URL}/deletePartnerUserRoleByUserId`,
      data: values,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(deletePartnerUserRoleSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(deletePartnerUserRoleError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(deletePartnerUserRoleError(err));
          return err.response;
        }
      });
}

export function deletePartnerUserRoleError(error) {
  return {
    type: deletePartnerUserRoleActions.DELETE_PARTNER_USER_ROLE_ERROR,
    payload: error,
  };
}

export function deletePartnerUserRoleSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: deletePartnerUserRoleActions.DELETE_PARTNER_USER_ROLE_SUCCESS,
      payload: props,
    });
  };
}
